import { styled } from '@mui/material/styles';
import { Button, Box } from '@mui/material';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  body {
    margin: 0;  
  }
`;

export const ModalOverlay = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
}));

export const ModalContainer = styled(Box)(({ theme }) => ({
  background: 'white',
  borderRadius: '8px',
  width: '400px',
  padding: '20px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  textAlign: 'center',
  position: 'relative',
}));

export const ModalHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: '1px solid #ddd',
  paddingBottom: '10px',
  marginBottom: '20px',
}));

export const ModalHeaderTitle = styled('h2')(({ theme }) => ({
  margin: 0,
  fontSize: '1.5rem',
}));

export const CloseButton = styled(Button)(({ theme }) => ({
  background: 'none',
  border: 'none',
  fontSize: '1.2rem',
  cursor: 'pointer',
}));

export const ModalBody = styled('div')(({ theme }) => ({
  textAlign: 'center',
}));

export const ModalBodyTitle = styled('h3')(({ theme }) => ({
  margin: 0,
  fontSize: '1.2rem',
  marginBottom: '10px',
}));

export const ModalBodySubtitle = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '1rem',
  color: '#555',
}));